import { render } from "./HTMLFormEditorView.vue?vue&type=template&id=efbd6f66&scoped=true"
import script from "./HTMLFormEditorView.vue?vue&type=script&lang=js"
export * from "./HTMLFormEditorView.vue?vue&type=script&lang=js"

import "./HTMLFormEditorView.vue?vue&type=style&index=0&id=efbd6f66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efbd6f66"]])

export default __exports__